import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import {
  Show,
  TextField,
  TopToolbar,
  ListButton,
  SimpleShowLayout,
  EditButton,
  useNotify,
  useRefresh,
  useRedirect,
} from "react-admin";

const ProviderTitle = ({ record }) => {
  return <span>Provider {record ? `"${record.name}"` : ""}</span>;
};

const ProviderActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
    <EditButton basePath={basePath} record={data} />
  </TopToolbar>
);

const ProvidersShow = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const onFailure = (error) => {
    notify(`Provider ${error.message}`, "error");
    sleep(2500).then(() => {
      redirect("/providers");
      refresh();
    });
  };

  return (
    <Show
      title={<ProviderTitle />}
      onFailure={onFailure}
      actions={<ProviderActions />}
      {...props}
    >
      <SimpleShowLayout>
        <TextField label="Company Name" source="name" />
        <TextField lable="Reference Contact Name" source="contact_name" />
        <TextField
          lable="Reference Contact Position"
          source="contact_position"
        />
        <TextField label="Relation" source="relation" />

        <TextField label="Email Address" source="email" type="email" />

        <TextField label="Phone Number" source="phone_number" />
      </SimpleShowLayout>
    </Show>
  );
};

export default ProvidersShow;
